import { MatBottomSheet } from '@angular/material/bottom-sheet';
import {
  Component,
  OnInit,
  Input,
  ViewChild,
  ElementRef,
  OnDestroy,
  HostListener,
} from '@angular/core';
import {
  BlogPostModel,
  BlogTagModel,
  BlogCommentModel,
  BlogReplyModel,
} from 'src/app/core/model/object/blog-model';
import { BlogUserModel } from 'src/app/core/model/object/blog-user-model';
import { Subscription } from 'rxjs';
import { BlogShared } from '../../general/shared/blog-shared';
import { BlogUserService } from 'src/app/data/repository/blog-repository/blog-user.service';
import { BlogService } from 'src/app/data/repository/blog-repository/blog.service';
import { LoadingShared } from '../../general/shared/loading-shared';
import { SnackBarService } from 'src/app/data/repository/utils-repository/snack-bar.service';
import { TextHelper } from 'src/app/utils/text-helper';
import { DateHelper } from 'src/app/utils/date-helper';
import { PopupTwoActionInputModel } from '../../general/two-action-popup/two-action-popup.component';
import { PopupShared } from '../../general/shared/popup-shared';
import { ReportBottomsheetModel } from '../../general/report-bottomsheet/report-bottomsheet.component';
import { BottomsheetShared } from '../../general/shared/bottomsheet-shared';
import { IosBottomsheetInputModel } from '../../general/ios-bottomsheet/ios-bottomsheet.component';
import { TribuneAnalyticsService } from 'src/app/data/repository/analytics-repository/tribune-analytics.service';
import { SetUsernameBottomsheetComponent } from '../set-username-bottomsheet/set-username-bottomsheet.component';
import { BlogDataService } from 'src/app/data/repository/blog-repository/blog-data.service';
import { ActivatedRoute } from '@angular/router';

@Component({
  selector: 'app-post-detail',
  templateUrl: './post-detail.component.html',
  styleUrls: ['./post-detail.component.scss'],
})
export class PostDetailComponent implements OnInit, OnDestroy {
  @Input() post: BlogPostModel;
  @Input() id: number;
  // @ViewChild('scrollMe') private myScrollContainer: ElementRef<HTMLDivElement>;

  tagRegex =
    /(#[^\u2000-\u206F\u2E00-\u2E7F\s\\'!"#$؟%&()*+،,\-.\/:;<=>?@\[\]^`{|}~]*)/g;
  mentionRegex = /(@)(?!\.)(?!\S*\.\.)(?!\S*\.[\s|$])([a-z0-9\.]+)(?=\s|$)/g;
  SWIPE_ACTION = { LEFT: 'swipeleft', RIGHT: 'swiperight' };
  commentPage = 0;
  postTextHtml: string;
  dataIsReady = false;
  bottomsheetData: ReportBottomsheetModel;
  selectedComment: BlogCommentModel;
  showMoreOption = false;
  showPostCommentReport = false;
  text = '';
  blogUser: BlogUserModel;
  isPersian = false;
  hasMention = false;
  dateLabelString = '';
  comments: BlogCommentModel[];
  newComments: BlogCommentModel[];
  hasMoreComments = false;
  showProfilePopup = false;
  showRemoveCommentPopup = false;
  showBlogWithTag = false;
  tagId = 10;
  removeCommentInput: PopupTwoActionInputModel;
  sendCommentInput: PopupTwoActionInputModel;
  removeCommentId: string;
  removeReplyId: string;
  isReplyActivated = false;
  replyUsername = '';
  isSending = false;
  commentId = '';
  replyId = '';
  iosBottomsheetInput: IosBottomsheetInputModel;

  commentLastLenght = 0;
  showTagView = false;
  showUserView = false;
  searchTagMode = false;
  searchUserMode = false;
  searchedTags: Array<BlogTagModel> = [];
  searchedUsers: BlogUserModel[] = [];

  selectedUsername = '';
  showProfile = false;
  profileId = 10;

  subscription1: Subscription;
  subscription2: Subscription;
  subscription3: Subscription;
  subscription4: Subscription;
  subscription5: Subscription;
  subscription6: Subscription;
  subscription7: Subscription;

  constructor(
    private blogShared: BlogShared,
    private blogUserService: BlogUserService,
    private blogService: BlogService,
    private loadingShared: LoadingShared,
    private snackBarService: SnackBarService,
    private textHelper: TextHelper,
    public dateHelper: DateHelper,
    private popupShared: PopupShared,
    private bottomsheetShared: BottomsheetShared,
    private tribuneAnalytics: TribuneAnalyticsService,
    private matBottomSheet: MatBottomSheet,
    private route: ActivatedRoute,
    private blogData: BlogDataService
  ) {
    this.getPost();
    this.subscription1 = this.blogShared.blogScrollToCommentsObs$.subscribe(
      (scroll) => {
        if (scroll) {
          setTimeout(() => {
            this.scrollToEnd();
          }, 0);
        }
      }
    );
    this.subscription2 =
      this.bottomsheetShared.closeIosBottomsheetObs$.subscribe((close) => {
        if (close) {
          this.closeMoreOptions();
        }
      });
    this.subscription3 = this.popupShared.dismissPopupObs$.subscribe(
      (dismiss) => {
        if (dismiss) {
          this.showProfilePopup = false;
          this.showRemoveCommentPopup = false;
        }
      }
    );
    this.subscription4 =
      this.bottomsheetShared.openReportBottomsheetObs$.subscribe((open) => {
        if (open) {
          setTimeout(() => {
            this.showPostReportBottomsheet();
          }, 300);
        }
      });
    this.subscription5 =
      this.bottomsheetShared.closeReportBottomsheetObs$.subscribe((close) => {
        if (close) {
          this.closePostCommentReportBottomsheet();
        }
      });
    this.subscription6 = this.popupShared.confirmRemovePopupObs$.subscribe(
      (confirm) => {
        if (confirm) {
          if (this.removeReplyId === '') {
            this.removeComment();
          } else {
            this.removeReply();
          }
        }
      }
    );
    this.blogUserService.getBlogUser().then((res) => {
      this.blogUser = res;
    });
    this.subscription7 = this.blogShared.usernameChangeObs$.subscribe(
      (changed) => {
        if (changed) {
          this.blogUser.userName = this.blogShared.newUsername;
        }
      }
    );
    this.id = parseInt(this.route.snapshot.paramMap.get('id'));
  }
  async getPost() {
    if (!this.blogData.getPost()) {
      const postId = this.route.snapshot.paramMap.get('id');
      await this.blogService.getBlogPost(postId).then((res) => {
        if (res.isSuccess()) {
          this.post = res.getData().getBlogPost();
          this.blogData.setPost(this.post);
          this.blogService.goToUserPost(this.post.user.userName, this.post.id);
          this.getComment();
        }
      });
    } else {
      this.post = this.blogData.getPost();
      this.getComment();
    }
  }
  ngOnInit() {
    this.commentId = '';
    this.replyId = '';
    this.isReplyActivated = false;
    // this.loadingShared.showLoading();
    // console.log(this.post);

    if (this.blogData.getScroolStatus() == true) {
      this.scrollToEnd();
    }
  }

  @HostListener('window:beforeunload')
  ngOnDestroy(): void {
    this.subscription1.unsubscribe();
    this.subscription2.unsubscribe();
    this.subscription3.unsubscribe();
    this.subscription4.unsubscribe();
    this.subscription5.unsubscribe();
    this.subscription6.unsubscribe();
    this.subscription7.unsubscribe();
  }
  getComment() {
    let _this = this;

    const postId = this.route.snapshot.paramMap.get('id');

    this.blogService.getBlogPostComments(postId, '', 5).then((res) => {
      if (res.isSuccess()) {
        this.comments = res.getData().getBlogCommentsArrayModel().comments;
        if (res.getData().getBlogCommentsArrayModel().count > 5) {
          this.hasMoreComments = true;
        }
        this.dataIsReady = true;
        this.comments = this.textHelper.prepareComments(
          this.comments,
          this.tagRegex,
          this.mentionRegex
        );
        // this.comments = this.textHelper.prepareReplies(this.comments);
        setTimeout(() => {
          this.convertCommentToHtml();
        }, 0);
        setTimeout(() => {
          this.convertReplyToHtml();
        }, 0);
        setTimeout(() => {
          if (this.post.text) {
            this.postTextHtml = this.textHelper.convertTextToHtml(
              this.post.text,
              this.tagRegex,
              this.mentionRegex
              );

            document.getElementById('postText' + this.id).innerHTML =
            this.postTextHtml;
            // console.log('postText2', this.postTextHtml, document.getElementById('postText' + this.id))
            document.querySelectorAll('.hashTag').forEach((el) => {
              if (el.getAttribute('listener') !== 'true') {
                el.addEventListener('click', function (e) {
                  // console.log(this.innerHTML)
                  _this.openBlogWithTag(this.innerHTML);
                });
                el.setAttribute('listener', 'true');
              }
            });
            document.querySelectorAll('.mention').forEach((el) => {
              if (el.getAttribute('listener') !== 'true') {
                el.addEventListener('click', function (e) {
                  // console.log(this.innerHTML)
                  _this.profile(this.innerHTML.substring(0, this.innerHTML.lenght - 1));
                });
                el.setAttribute('listener', 'true');
              }
            });
            console.log('postText', this.comments)
          }
        }, 0);
      } else {
        this.snackBarService.showSnackBar('خطا در برقراری ارتباط با سرور!');
      }
      this.loadingShared.hideLoading();
    });
    this.isPersian = this.textHelper.hasTextPersian(this.post.text);
    this.hasMention = this.textHelper.textHasMention(this.post.text);
    this.dateLabelString = this.dateHelper.getPostTimeLabel(
      this.post.createdAt
    );
  }
  likeSelected() {
    if (this.checkUsername()) {
      this.loadingShared.showLoading();
      if (this.post.isLiked) {
        this.blogService.postDislike(this.post.id).then((res) => {
          if (res.isSuccess()) {
            this.post.isLiked = false;
            this.post.likes--;
          } else {
            this.snackBarService.showSnackBar('خطا در برقراری ارتباط با سرور!');
          }
          this.loadingShared.hideLoading();
        });
      } else {
        this.blogService.postLike(this.post.id).then((res) => {
          if (res.isSuccess()) {
            this.post.isLiked = true;
            this.post.likes++;
          } else {
            this.snackBarService.showSnackBar('خطا در برقراری ارتباط با سرور!');
          }
          this.loadingShared.hideLoading();
        });
      }
    }
  }

  showMoreComments() {
    this.loadingShared.showLoading();
    this.blogService
      .getBlogPostComments(
        this.post.id,
        this.comments[this.comments.length - 1].createdAt,
        5
      )
      .then((res) => {
        if (res.isSuccess()) {
          this.newComments = res.getData().getBlogCommentsArrayModel().comments;
          this.newComments = this.textHelper.prepareComments(
            this.newComments,
            this.tagRegex,
            this.mentionRegex
          );
          this.comments = [...this.comments, ...this.newComments];
          setTimeout(() => {
            this.convertCommentToHtml();
          }, 0);
          setTimeout(() => {
            this.convertReplyToHtml();
          }, 0);
          this.newComments = [];
          this.commentPage++;
          if (
            res.getData().getBlogCommentsArrayModel().count >
            5 * (this.commentPage + 1)
          ) {
            this.hasMoreComments = true;
          } else {
            this.hasMoreComments = false;
          }
        } else {
          this.snackBarService.showSnackBar('خطا در برقراری ارتباط با سرور!');
        }
        this.loadingShared.hideLoading();
      });
  }

  showMoreOptions() {
    if (this.checkUsername()) {
      this.bottomsheetShared.shareLink =
        'https://bentoapp.info/posts/' + this.post.id;
      this.iosBottomsheetInput = new IosBottomsheetInputModel(
        ['گزارش ...', 'اشتراک گذاری'],
        'انصراف'
      );
      this.showMoreOption = true;
    }
  }

  closeMoreOptions() {
    this.showMoreOption = false;
  }

  showPostReportBottomsheet() {
    const titles = ['محتوای پست غیراخلاقیه.', 'محتوای پست اشتباهه.'];
    this.bottomsheetData = new ReportBottomsheetModel(
      'post',
      'گزارش',
      'علت گزارش این پست رو انتخاب کنید.',
      titles,
      this.post.id,
      ''
    );
    this.showPostCommentReport = true;
  }

  closePostCommentReportBottomsheet() {
    this.showPostCommentReport = false;
  }

  showCommentReportBottomsheet(id: string) {
    const titles = ['محتوای نظر غیراخلاقیه.', 'محتوای نظر اشتباهه.'];
    this.bottomsheetData = new ReportBottomsheetModel(
      'comment',
      'گزارش',
      'علت گزارش این نظر رو انتخاب کنید.',
      titles,
      this.post.id,
      id
    );
    this.showPostCommentReport = true;
    document.getElementById('id' + this.id + 'commentholder' + id).style.right =
      '0';
  }

  showReplyReportBottomsheet(id: string) {
    const titles = ['محتوای نظر غیراخلاقیه.', 'محتوای نظر اشتباهه.'];
    this.bottomsheetData = new ReportBottomsheetModel(
      'reply',
      'گزارش',
      'علت گزارش این نظر رو انتخاب کنید.',
      titles,
      this.post.id,
      id
    );
    this.showPostCommentReport = true;
    document.getElementById('id' + this.id + 'replyholder' + id).style.right =
      '0';
  }

  activateReply(comment: BlogCommentModel) {
    this.selectedComment = comment;
    this.replyUsername = comment.user.userName + '@';
    this.isReplyActivated = true;
    document.getElementById(
      'id' + this.id + 'commentholder' + comment.id
    ).style.right = '0';
    document.getElementById('id' + this.id + 'replyActivated').style.top = '0';
  }

  activateReplyReply(comment: BlogCommentModel, reply: BlogReplyModel) {
    this.selectedComment = comment;
    this.replyUsername = reply.user.userName + '@';
    this.isReplyActivated = true;
    document.getElementById(
      'id' + this.id + 'replyholder' + reply.id
    ).style.right = '0';
    document.getElementById('id' + this.id + 'replyActivated').style.top = '0';
  }

  deactivateReply() {
    document.getElementById('id' + this.id + 'replyActivated').style.top =
      '41px';
    this.isReplyActivated = false;
  }

  changeReplyPage(comment: BlogCommentModel) {
    if (comment.replies.length <= comment.repliesPage * 3) {
      comment.repliesPage = 0;
    } else {
      comment.repliesPage++;
    }
    setTimeout(() => {
      this.convertNewReplyToHtml(comment);
    }, 10);
  }

  sendCommentOrReply() {
    if (!this.isSending) {
      this.isSending = true;
      if (this.text !== '') {
        // if (this.blogUser.userName !== '') {
        if (this.checkUsername()) {
          if (this.isReplyActivated) {
            const t =
              '@' +
              this.replyUsername.slice(0, this.replyUsername.length - 1) +
              ' ' +
              this.text;
            this.loadingShared.showLoading();
            this.blogService
              .createReply(this.selectedComment.id, t)
              .then((res) => {
                if (res.isSuccess()) {
                  this.text = '';
                  setTimeout(() => {
                    this.autoGrow(
                      this.isReplyActivated,
                      this.post.featuredImagePath !== ''
                    );
                  }, 20);
                  let reply = res.getData().getBlogReply();
                  reply = this.textHelper.prepareReply(reply, this.tagRegex, this.mentionRegex);
                  this.selectedComment.replies.push(reply);
                  setTimeout(() => {
                    this.convertReplyToHtml();
                  }, 0);
                  this.deactivateReply();
                  this.snackBarService.showSnackBar('جواب شما اضافه شد.');
                } else {
                  this.snackBarService.showSnackBar(
                    'خطا در برقراری ارتباط با سرور!'
                  );
                }
                this.isSending = false;
                this.loadingShared.hideLoading();
              });
          } else {
            this.loadingShared.showLoading();
            this.blogService
              .createComment(this.post.id, this.text)
              .then((res) => {
                if (res.isSuccess()) {
                  this.text = '';
                  setTimeout(() => {
                    this.autoGrow(
                      this.isReplyActivated,
                      this.post.featuredImagePath !== ''
                    );
                  }, 20);
                  let comment = res.getData().getBlogComment();
                  comment = this.textHelper.prepareComment(
                    comment,
                    this.tagRegex,
                    this.mentionRegex
                  );
                  this.post.comments++;
                  this.comments.unshift(comment);
                  setTimeout(() => {
                    this.convertCommentToHtml();
                  }, 0);
                  this.snackBarService.showSnackBar('نظر شما اضافه شد.');
                } else {
                  this.snackBarService.showSnackBar(
                    'خطا در برقراری ارتباط با سرور!'
                  );
                }
                this.isSending = false;
                this.loadingShared.hideLoading();
              });
          }
        } else {
          this.isSending = false;
          // this.sendCommentInput = new PopupTwoActionInputModel('send', 'برای درج نظر، حتما باید نام کاربری بسازید'
          // , 'الان می‌سازم', 'بعدا');
          // this.showProfilePopup = true;
        }
      } else {
        this.isSending = false;
        this.snackBarService.showSnackBar('لطفا نظر خود را وارد کنید.');
      }
    }
  }

  search() {
    if (this.text.charAt(this.text.length - 1) === '#') {
      this.searchTagMode = true;
      this.commentLastLenght = this.text.length;
    } else if (this.text.charAt(this.text.length - 1) === '@') {
      this.searchUserMode = true;
      this.commentLastLenght = this.text.length;
    } else if (this.text.charAt(this.text.length - 1) === ' ') {
      this.searchTagMode = false;
      this.showTagView = false;
    }
    if (this.searchTagMode) {
      if (this.commentLastLenght > this.text.length) {
        this.searchTagMode = false;
        this.showTagView = false;
      } else if (this.commentLastLenght === this.text.length) {
        this.searchTagMode = true;
        this.showTagView = false;
      } else {
        this.showTagView = true;
        this.loadingShared.showLoading();
        const text = this.text.slice(this.commentLastLenght, this.text.length);
        this.blogService
          .searchTag(
            this.textHelper.replaceArabicLettersWithPersian(
              this.text.slice(this.commentLastLenght, this.text.length)
            )
          )
          .then((res) => {
            if (res.isSuccess()) {
              if (
                text ===
                this.text.slice(this.commentLastLenght, this.text.length)
              ) {
                this.searchedTags = res.getData().getBlogTagArray();
              }
            } else {
              this.searchedTags = [];
            }
            this.loadingShared.hideLoading();
          });
      }
    } else if (this.searchUserMode) {
      if (this.commentLastLenght > this.text.length) {
        this.searchUserMode = false;
        this.showUserView = false;
      } else if (this.commentLastLenght === this.text.length) {
        this.searchUserMode = true;
        this.showUserView = false;
      } else {
        this.showUserView = true;
        this.loadingShared.showLoading();
        const text = this.text.slice(this.commentLastLenght, this.text.length);
        this.blogService
          .searchUser(
            this.textHelper.replaceArabicLettersWithPersian(
              this.text.slice(this.commentLastLenght, this.text.length)
            )
          )
          .then((res) => {
            if (res.isSuccess()) {
              if (
                text ===
                this.text.slice(this.commentLastLenght, this.text.length)
              ) {
                this.searchedUsers = res.getData().getBlogUsers();
              }
            } else {
              this.searchedUsers = [];
            }
            this.loadingShared.hideLoading();
          });
      }
    }
  }

  replaceTagInSearch(tag: BlogTagModel) {
    this.text = this.text.slice(0, this.commentLastLenght) + tag.title + ' ';
    this.searchTagMode = false;
    this.showTagView = false;
    document.getElementById('textarea').focus();
  }

  replaceUsernameInSearch(username: string) {
    this.text = this.text.slice(0, this.commentLastLenght) + username + ' ';
    this.searchUserMode = false;
    this.showUserView = false;
    document.getElementById('textarea').focus();
  }

  removeCommentPopup(id: string) {
    this.removeCommentInput = new PopupTwoActionInputModel(
      'remove',
      'می‌خواهید نظر خود را حذف کنید؟',
      'بله',
      'خیر'
    );
    this.showRemoveCommentPopup = true;
    this.removeCommentId = id;
    this.removeReplyId = '';
  }

  removeComment() {
    this.loadingShared.showLoading();
    this.blogService.deleteComment(this.removeCommentId).then((res) => {
      if (res.isSuccess()) {
        this.comments.forEach((comment, index) => {
          if (comment.id === this.removeCommentId) {
            this.comments.splice(index, 1);
            return;
          }
        });
        this.commentId = '';
        this.snackBarService.showSnackBar('نظر شما حذف شد.');
      } else {
        this.snackBarService.showSnackBar('خطا در برقراری ارتباط با سرور!');
      }
      this.loadingShared.hideLoading();
    });
  }

  removeReplyPopup(commentId: string, replyId: string) {
    this.removeCommentInput = new PopupTwoActionInputModel(
      'remove',
      'می‌خواهید نظر خود را حذف کنید؟',
      'بله',
      'خیر'
    );
    this.showRemoveCommentPopup = true;
    this.removeReplyId = replyId;
    this.removeCommentId = commentId;
  }
  closeDetail() {
    this.blogService.goback();
  }
  removeReply() {
    this.loadingShared.showLoading();
    this.blogService.deleteReply(this.removeReplyId).then((res) => {
      if (res.isSuccess()) {
        this.comments.forEach((comment) => {
          if (comment.id === this.removeCommentId) {
            comment.replies.forEach((reply, index) => {
              if (reply.id === this.removeReplyId) {
                comment.replies.splice(index, 1);
                return;
              }
            });
            return;
          }
        });
        this.replyId = '';
        this.snackBarService.showSnackBar('جواب شما حذف شد.');
      } else {
        this.snackBarService.showSnackBar('خطا در برقراری ارتباط با سرور!');
      }
      this.loadingShared.hideLoading();
    });
  }

  scrollToEnd() {
    setTimeout(() => {
      const el = document.getElementById('comment');
      if (el) el.scrollIntoView();
    }, 500);
  }

  openBlogWithTag(tag: string) {
    const selectedTag = new BlogTagModel('', tag, 1);
    // this.blogShared.blogSelectedTag = selectedTag;
    // this.blogShared.blogZIndex++;
    // this.tagId = this.blogShared.blogZIndex;
    // this.showBlogWithTag = true;
    // setTimeout(() => {
    //   document.getElementById('blogWithTag' + this.id).style.zIndex =
    //     this.blogShared.blogZIndex.toString();
    //   document.getElementById('blogWithTag' + this.id).style.right = '0';
    // }, 100);
    this.blogService.goToSearchTag();
    this.tribuneAnalytics.analyticTribuneHashtagClicked();
  }

  closeBlogWithTag() {
    // this.blogShared.blogZIndex--;
    // document.getElementById('blogWithTag' + this.id).style.right = '100%';
    // setTimeout(() => {
    //   this.showBlogWithTag = false;
    // }, 300);
  }

  profile(username: string) {
    this.blogService.goToUserProfile(username);
    this.blogData.setProfileScrollStatus(false);
    this.blogData.setProfileLastScroll(0);
    this.blogData.setProfilePostPage(5);

    // this.selectedUsername = username;
    // this.blogShared.blogZIndex++;
    // this.profileId = this.blogShared.blogZIndex;
    // this.showProfile = true;
    // setTimeout(() => {
    //   document.getElementById('profilePage' + this.id).style.zIndex =
    //     this.blogShared.blogZIndex.toString();
    //   document.getElementById('profilePage' + this.id).style.right = '0';
    // }, 100);
  }

  closeProfile() {
    // this.blogShared.blogZIndex--;
    // document.getElementById('profilePage' + this.id).style.right = '100%';
    // // this._sharedService.animateDownButton();
    // setTimeout(() => {
    //   this.showProfile = false;
    // }, 300);
  }

  autoGrow(isReplyActivated: boolean, hasImage: boolean) {
    document.getElementById('textarea').style.height = '5px';
    document.getElementById('textarea').style.height =
      document.getElementById('textarea').scrollHeight - 4 + 'px';
    document.getElementById('botHolder').style.height =
      (document.getElementById('textarea').scrollHeight + 40).toString() + 'px';
    if (hasImage) {
      if (isReplyActivated) {
        document.getElementById('scrollMe').style.height =
          'calc( 100% - ' +
          (document.getElementById('textarea').scrollHeight + 138).toString() +
          'px )';
      } else {
        document.getElementById('scrollMe').style.height =
          'calc( 100% - ' +
          (document.getElementById('textarea').scrollHeight + 97).toString() +
          'px )';
      }
    } else {
      if (isReplyActivated) {
        document.getElementById('scrollMe').style.height =
          'calc( 100% - ' +
          (document.getElementById('textarea').scrollHeight + 147).toString() +
          'px )';
      } else {
        document.getElementById('scrollMe').style.height =
          'calc( 100% - ' +
          (document.getElementById('textarea').scrollHeight + 106).toString() +
          'px )';
      }
    }
  }

  convertCommentToHtml() {
    this.comments.forEach((comment) => {
      document.getElementById(
        'id' + this.id + 'comment' + comment.id
      ).innerHTML = comment.text;
    });
    let _this = this;
    document.querySelectorAll('.hashTag').forEach((el) => {
      if (el.getAttribute('listener') !== 'true') {
        el.addEventListener('click', function (e) {
          // console.log(this.innerHTML)
          _this.openBlogWithTag(this.innerHTML);
        });
        el.setAttribute('listener', 'true');
      }
    });
    document.querySelectorAll('.mention').forEach((el) => {
      if (el.getAttribute('listener') !== 'true') {
        el.addEventListener('click', function (e) {
          // console.log(this.innerHTML)
          _this.profile(this.innerHTML.substring(0, this.innerHTML.length - 1));
        });
        el.setAttribute('listener', 'true');
      }
    });
  }

  convertReplyToHtml() {
    this.comments.forEach((comment) => {
      comment.replies.forEach((reply, i) => {
        if (
          i >= comment.replies.length - comment.repliesPage * 3 &&
          i < comment.replies.length - (comment.repliesPage - 1) * 3
        ) {
          document.getElementById(
            'id' + this.id + 'reply' + reply.id
          ).innerHTML = reply.text;
        }
      });
    });
    let _this = this;
    document.querySelectorAll('.hashTag').forEach((el) => {
      if (el.getAttribute('listener') !== 'true') {
        el.addEventListener('click', function (e) {
          // console.log(this.innerHTML)
          _this.openBlogWithTag(this.innerHTML);
        });
        el.setAttribute('listener', 'true');
      }
    });
    document.querySelectorAll('.mention').forEach((el) => {
      if (el.getAttribute('listener') !== 'true') {
        el.addEventListener('click', function (e) {
          // console.log(this.innerHTML)
          _this.profile(this.innerHTML.substring(0, this.innerHTML.length - 1));
        });
        el.setAttribute('listener', 'true');
      }
    });
  }

  convertNewReplyToHtml(comment: BlogCommentModel) {
    comment.replies.forEach((reply, i) => {
      if (
        i >= comment.replies.length - comment.repliesPage * 3 &&
        i < comment.replies.length - (comment.repliesPage - 1) * 3
      ) {
        document.getElementById('id' + this.id + 'reply' + reply.id).innerHTML =
          reply.text;
      }
    });
    let _this = this;
    document.querySelectorAll('.hashTag').forEach((el) => {
      if (el.getAttribute('listener') !== 'true') {
        el.addEventListener('click', function (e) {
          // console.log(this.innerHTML)
          _this.openBlogWithTag(this.innerHTML);
        });
        el.setAttribute('listener', 'true');
      }
    });
    document.querySelectorAll('.mention').forEach((el) => {
      if (el.getAttribute('listener') !== 'true') {
        el.addEventListener('click', function (e) {
          // console.log(this.innerHTML)
          _this.profile(this.innerHTML.substring(0, this.innerHTML.length - 1));
        });
        el.setAttribute('listener', 'true');
      }
    });
  }

  swipeComment(
    comment: BlogCommentModel,
    action: string = this.SWIPE_ACTION.RIGHT,
    id
  ) {
    if (this.checkUsername()) {
      if (action === this.SWIPE_ACTION.RIGHT) {
        if (this.commentId !== '') {
          document.getElementById(
            'id' + id + 'commentholder' + this.commentId
          ).style.right = '0';
        }
        if (this.replyId !== '') {
          document.getElementById(
            'id' + id + 'replyholder' + this.replyId
          ).style.right = '0';
        }
        document.getElementById(
          'id' + id + 'commentholder' + comment.id
        ).style.right = '-72px';
        this.commentId = comment.id;
      }
      if (action === this.SWIPE_ACTION.LEFT) {
        // this.commentId = '';
        document.getElementById(
          'id' + id + 'commentholder' + comment.id
        ).style.right = '0';
      }
    }
  }

  swipeReply(
    reply: BlogReplyModel,
    action: string = this.SWIPE_ACTION.RIGHT,
    id
  ) {
    if (this.checkUsername()) {
      if (action === this.SWIPE_ACTION.RIGHT) {
        if (this.commentId !== '') {
          document.getElementById(
            'id' + id + 'commentholder' + this.commentId
          ).style.right = '0';
        }
        if (this.replyId !== '') {
          document.getElementById(
            'id' + id + 'replyholder' + this.replyId
          ).style.right = '0';
        }
        document.getElementById(
          'id' + id + 'replyholder' + reply.id
        ).style.right = '-72px';
        this.replyId = reply.id;
      }
      if (action === this.SWIPE_ACTION.LEFT) {
        // this.replyId = '';
        document.getElementById(
          'id' + id + 'replyholder' + reply.id
        ).style.right = '0';
      }
    }
  }

  checkUsername(): boolean {
    if (this.blogUser.userName === '') {
      this.matBottomSheet.open(SetUsernameBottomsheetComponent, {
        panelClass: 'custom-bottomsheet-container',
      });
      return false;
    }
    return true;
  }
}
